import { render, staticRenderFns } from "./DelegationManagement.vue?vue&type=template&id=7c09ba12&"
import script from "./DelegationManagement.js?vue&type=script&lang=js&"
export * from "./DelegationManagement.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports